"use client";

import MapPinIcon from "@heroicons/react/24/outline/MapPinIcon";
import toast from "react-hot-toast";
import { useUserLocation } from "@/context/UserLocationContext";
import { useTranslation } from "@/hooks/translationContext";

export default function FeaturedVenuesNearbyButton({
  venueLabel,
  label = "Yakındakiler",
}: {
  venueLabel: string;
  label?: string;
}) {
  const { t } = useTranslation();
  const { enableSortByDistance } = useUserLocation();

  const onClick = () => {
    toast.success(
      t("header-nearby-sorted-info", { venueLabel }),
      { duration: 4000 }
    );
    enableSortByDistance();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="flex flex-col items-center gap-1 px-2 py-1 shrink-0"
    >
      <MapPinIcon className="w-5 h-5 text-[#cd0241]" />
      <span className="text-xs font-medium text-[#cd0241] whitespace-nowrap">
        {label}
      </span>
    </button>
  );
}
